import { getIn } from 'formik'
import { omit } from 'lodash'
import PropTypes from 'prop-types'
import ReactDropzone from 'react-dropzone-outdated'
import { useIntl } from 'react-intl'

import { formik } from '@/components/Form/propTypes'

import messages from './messages'

function Dropzone(props: any) {
  const intl = useIntl()

  const handleDrop = (acceptedFiles: any, rejectedFiles: any) => {
    const { formik, multiple, name, onDrop } = props

    if (onDrop) {
      onDrop(acceptedFiles, rejectedFiles)
    }

    if (rejectedFiles.length > 0) {
      formik.setFieldError(
        name,
        rejectedFiles.map(({ name }: any) => intl.formatMessage(messages.rejectedError, { name })).join(' ')
      )
    } else {
      let value = acceptedFiles[0]

      if (multiple) {
        value = getIn(formik.values, name, [])

        if (!Array.isArray(value)) {
          value = []
        }

        formik.setFieldValue(name, value.concat(acceptedFiles), false)
      }

      formik.setFieldValue(name, value, false)
    }
  }

  const { accept, children, className, disabled, formik, multiple, name } = props
  const rest = omit(props, ['accept', 'children', 'className', 'disabled', 'formik', 'multiple', 'name', 'value'])

  // `onBlur` doesn't work for file inputs so we have to mimick it's behavior using `onClick` and `onDragEnter`
  return (
    <ReactDropzone
      data-testid={'dropzone'}
      accept={accept}
      acceptClassName={`${className}--accepted`}
      activeClassName={`${className}--active`}
      className={className}
      disabled={disabled}
      disabledClassName={`${className}--disabled`}
      inputProps={{ ...rest, onBlur: formik.handleBlur }}
      multiple={multiple}
      name={name}
      onDrop={handleDrop}
      rejectClassName={`${className}--rejected`}
    >
      {children}
    </ReactDropzone>
  )
}

Dropzone.displayName = 'Dropzone'

Dropzone.propTypes = {
  accept: PropTypes.oneOfType([PropTypes.string, PropTypes.arrayOf(PropTypes.string)]),
  children: PropTypes.node,
  className: PropTypes.string,
  disabled: PropTypes.bool,
  formik: formik.isRequired,

  multiple: PropTypes.bool,
  name: PropTypes.string.isRequired,
  onDrop: PropTypes.func,
  value: PropTypes.object
}

Dropzone.defaultProps = {
  accept: undefined,
  children: null,
  className: '',
  disabled: false,
  multiple: false,
  onDrop: null,
  value: {}
}

export default Dropzone
